import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";

const CardListComponent = ({
  item,
  jobListDetails,
  toggleModalDescription,
  toggleModalFormApplication,
  setActiveID,
}) => {
  const [details, setDetails] = useState(false);

  useEffect(() => {
    if (jobListDetails.length > 0) {
      setDetails(
        jobListDetails.find((thisItem) => thisItem.adId === item.adId)
      );
    }
  }, [jobListDetails, item.adId]);

  useEffect(() => {}, [details]);

  useEffect(() => {}, [jobListDetails]);

  useEffect(() => {}, [details]);

  function getExcerpt(element, maxLength = 100, elementType) {
    if (!element || element.nodeName !== elementType.toUpperCase()) {
      return "";
    }

    const text = element.textContent.trim();

    if (text.length <= maxLength) {
      return text;
    }

    const excerpt = text.slice(0, maxLength) + "...";

    return excerpt;
  }

  const findItemFieldDetails = (id, field, enableExcerpt = false) => {
    const foundItem = jobListDetails.find((item) => item.adId === id);

    if (foundItem) {
      if (enableExcerpt) {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = foundItem[field];
        const element = tempElement.querySelectorAll("li")[0] ?? "";
        return getExcerpt(element, 100, "li");
      } else {
        return foundItem[field];
      }
    } else {
      return false;
    }
  };

  const getJobDetailValue = (jobListDetails, item) => {
    return jobListDetails.find((itemloc) => itemloc.adId === item?.adId)?.portal?.fields[1]?.value;
  };

  return (
    <li className="job-item">
      <div className="job-details">
        <h5 style={{ color: "#21419B", fontWeight: "bold" }}>{item.title}</h5>
        <p>
          {findItemFieldDetails(item?.adId, "description", true) || (
            <div className="FB-Loading-Card">
              <div className="FB-Loading-FirstBox-3rdRow"></div>
              <div className="FB-Loading-FirstBox-4thRow"></div>
              <div className="FB-Loading-FirstBox-5thRow"></div>
            </div>
          )}
          <br />
          <a
            onClick={() => {
              toggleModalDescription();
              setActiveID(item.adId);
            }}
          >
            Read More
          </a>
        </p>
        <div className="card-bottom">
          <span
            style={{ color: "#CE2029", fontSize: "14px", fontWeight: "bold" }}
          >
            {getJobDetailValue(jobListDetails, item)}
          </span>

          <button
            disabled={item.state === "Draft"}
            onClick={() => {
              if (item.state !== "Draft") {
                toggleModalFormApplication();
                setActiveID(item.adId);
              }
            }}
            className="apply-button"
            style={{ width: "150px" }}
          >
            Apply
          </button>
        </div>
      </div>
    </li>
  );
};

export default CardListComponent;
